<template>
    <div>
        <el-dialog
            title="批量创建电费项目"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="1000px">
            <multi-file-choose :taxFiles.sync='fileList' placeholder='支持xls/xlsx格式，单次最多导入10000条' accept='.xls,.xlsx' :max="1"></multi-file-choose>
            <div slot="footer" class="a-flex-rfsc">
                <div class="a-flex-1 a-flex-rfsc">
                    <el-link type="primary" underline @click="handleDownloadFile">模版下载</el-link>
                </div>
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import multiFileChoose from '../../components/formcy/multi-file-choose.vue';
    export default {
        components: {
            multiFileChoose
        },
        data() {
            return {
                fileList: [],
                dialogVisible: false,
            }
        },
        watch: {
            dialogVisible: {
                handler (val) {
                    if(!val) {
                        this.$refs['upload'].clearFiles()
                    }
                }
            }
        },
        methods:{
            submit () {
                this.dialogVisible = false
            },
            handleDownloadFile () {
                this.$Utils.download('','电费项目批量添加模版')
            }
        }
    }
</script>

<style lang="scss" scoped>
    
</style>